import { render, staticRenderFns } from "./SelfDeparture.vue?vue&type=template&id=19836bba&scoped=true&"
import script from "./SelfDeparture.vue?vue&type=script&lang=js&"
export * from "./SelfDeparture.vue?vue&type=script&lang=js&"
import style0 from "./SelfDeparture.vue?vue&type=style&index=0&id=19836bba&prod&lang=scss&scoped=true&"
import style1 from "./SelfDeparture.vue?vue&type=style&index=1&id=19836bba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19836bba",
  null
  
)

export default component.exports